import { Copy, Check, FloppyDisk, PencilSimple, ArrowsClockwise, FilePdf, FileText, GoogleLogo, CodeSimple } from "@phosphor-icons/react";

export const ContentActionBar = ({
  onCopyDraft, onCopyAll, onSave, onEdit, onRepurpose,
  onExportPdf, onCopyMarkdown, onCopyHtml, onOpenGoogleDocs,
  copiedDraft, copiedAll, copiedMarkdown, copiedHtml,
  isSaved, saving, exporting, gdocsExporting,
}) => (
  <div className="sticky top-16 z-40 bg-[var(--bg-base)]/90 backdrop-blur-xl border border-[var(--border)] rounded-lg p-2 sm:p-3 flex flex-wrap gap-1.5 sm:gap-2">
    <ActionBtn onClick={onCopyDraft} icon={copiedDraft ? Check : Copy} label={copiedDraft ? "Copied!" : "Copy Draft"} primary testId="copy-draft-button" />
    <ActionBtn onClick={onCopyAll} icon={copiedAll ? Check : Copy} label={copiedAll ? "Copied!" : "Copy All"} testId="copy-all-button" />
    {onSave && !isSaved && (
      <ActionBtn onClick={onSave} disabled={saving} icon={FloppyDisk} label={saving ? "Saving..." : "Save"} testId="save-history-button" />
    )}
    {isSaved && (
      <span className="flex items-center gap-1.5 px-2.5 sm:px-4 py-2 text-xs sm:text-sm text-[var(--success)]" data-testid="saved-indicator">
        <Check size={16} /> <span className="hidden sm:inline">Saved</span>
      </span>
    )}
    {onEdit && <ActionBtn onClick={onEdit} icon={PencilSimple} label="Edit" testId="edit-regenerate-button" />}
    {onRepurpose && <ActionBtn onClick={onRepurpose} icon={ArrowsClockwise} label="Repurpose" hoverColor="hover:text-[var(--success)] hover:border-[var(--success)]/30" testId="repurpose-button" />}
    <ActionBtn onClick={onExportPdf} disabled={exporting} icon={FilePdf} label={exporting ? "Exporting..." : "PDF"} hoverColor="hover:text-red-400 hover:border-red-400/30" testId="export-pdf-button" />
    <ActionBtn onClick={onCopyMarkdown} icon={copiedMarkdown ? Check : FileText} label={copiedMarkdown ? "Copied!" : "MD"} testId="copy-markdown-button" />
    <ActionBtn onClick={onOpenGoogleDocs} disabled={gdocsExporting} icon={GoogleLogo} label={gdocsExporting ? "Exporting..." : "Docs"} hoverColor="hover:text-blue-400 hover:border-blue-400/30" testId="open-google-docs-button" />
    <ActionBtn onClick={onCopyHtml} icon={copiedHtml ? Check : CodeSimple} label={copiedHtml ? "Copied!" : "HTML"} hoverColor="hover:text-orange-400 hover:border-orange-400/30" testId="copy-html-button" />
  </div>
);

function ActionBtn({ onClick, disabled, icon: Icon, label, primary, hoverColor = "", testId }) {
  const base = primary
    ? "bg-[#FF4400] text-white hover:bg-[#FF6633]"
    : `bg-[var(--bg-raised)] text-[var(--text-secondary)] hover:text-[var(--text-primary)] border border-[var(--border-strong)] ${hoverColor}`;
  return (
    <button onClick={onClick} disabled={disabled}
      className={`flex items-center gap-1.5 px-2.5 sm:px-4 py-2 rounded-md text-xs sm:text-sm font-medium transition-colors duration-200 disabled:opacity-50 ${base}`}
      data-testid={testId}>
      <Icon size={16} />
      <span className="hidden sm:inline">{label}</span>
    </button>
  );
}
